import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import { Badge, Card, CardBody, Col, Row } from "reactstrap"
import moment from "moment"
import FullCalendar from "@fullcalendar/react" // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid" // a plugin!
import interactionPlugin from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import AttendanceAction from "store/attendance-resource/actions"
import DetailAttendance from "../Detail"

const TabEngravingHistory = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pageState, setPageState] = React.useState("calendar")
  const [clickedDate, setClickedDate] = React.useState(null)

  const events = React.useMemo(() => {
    const current = []
    // console.log(store.attendance.history.data, 'before')
    store.attendance.history.data.forEach((i, k) => {
      if (i.clockIn != "00:00" && i.clockIn) {
        current.push({
          date: i.attendanceDate,
          className: "bg-warning",
          title: i.clockIn,
          // start: moment(`${i.attendanceDate} ${i.clockIn}`).unix() * 1000,
        })
      }
      if (i.clockOut != "00:00" && i.clockOut) {
        current.push({
          date: i.attendanceDate,
          className: "bg-success",
          title: i.clockOut,
          // start: moment(`${i.attendanceDate} ${i.clockOut}`).unix() * 5000,
        })
      }
    })
    // console.log(current, 'current')
    return current
  }, [store.attendance.history.loading])

  return (
    <>
      <Card>
        <CardBody className="p-3">
          {pageState == "calendar" ? (
            <>
              <Row className="mb-3">
                <Col>
                  <Badge color="warning" pill>
                    出勤
                  </Badge>
                  <Badge color="success" pill>
                    退勤
                  </Badge>
                </Col>
              </Row>
              <FullCalendar
                plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                themeSystem="bootstrap"
                headerToolbar={{
                  left: "",
                  center: "title",
                }}
                buttonText={{
                  today: "本日",
                }}
                events={events}
                editable={true}
                eventClick={e => {
                  setClickedDate(e.event.startStr)
                  setPageState("detail")
                }}
                dateClick={e => {
                  setClickedDate(e.dateStr)
                  setPageState("detail")
                }}
                selectable={true}
                droppable={false}
                locale="ja"
                datesSet={e => {
                  const date = moment(e.startStr).date()
                  const dateMonth = moment(e.startStr).month()

                  let year = moment(e.startStr).year()
                  let month = moment(e.startStr).month()
                  if (date > 1) {
                    month = dateMonth + 2
                  } else {
                    month = dateMonth + 1
                  }

                  if (dateMonth == 11 && date > 1) {
                    month = 1
                    year = year + 1
                  }
                  dispatch(AttendanceAction.getMonthHistory({ year, month }))
                }}
              />
            </>
          ) : (
            <DetailAttendance
              params={{ date: clickedDate }}
              cancel={() => setPageState("calendar")}
            />
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default TabEngravingHistory
